const errors = {
  UNKNOWN: 'UNKNOWN',
  NOT_IMPLEMENTED: 'NOT_IMPLEMENTED',
  LOGIN_REQUIRED: 'LOGIN_REQUIRED',

  STATUS_OK: 200,
}

export default errors
